const CheckGreen = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M21.694 5.72 7.5 19.388l-5.193-5.001 1.387-1.441L7.5 16.611 20.307 4.28l1.387 1.44z" fill="#1DAC2C" />
    </svg>
)

export default CheckGreen;